import { CategoryFacade } from "../category/category.facade";
import { Category } from "../category/category.model";
import { ContactTypeStoreFacade } from "./contact-type.store-facade";
import { ContactTypeApiFacade } from "./contact-type.api-facade";

export class ContactTypeFacade extends CategoryFacade<Category, ContactTypeApiFacade, ContactTypeStoreFacade> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/contact-type/contact-type.facade.ts